import { put } from 'redux-saga/effects'
import { IPcr } from '../../../pcr/store/pcr.types'
import { setMotorVehicleIncident } from '../store/motorVehicleIncident.actions'

export function* getMotorVehicleIncident(pcrDoc: IPcr) {
  const { ccHpiMotorVehicleIncident } = pcrDoc

  if (ccHpiMotorVehicleIncident && Object.keys(ccHpiMotorVehicleIncident).length !== 0) {
    yield put(setMotorVehicleIncident(ccHpiMotorVehicleIncident))
  }
}
